import {Lang} from 'yougile-lang'
import {
  createDataObjectId,
  createDefaultRepeatTemplate,
  DataObjectId,
  Hub,
  HubJSON,
  repeatTemplatesContainerId
} from 'yougile-model'
import {globals} from '@extensions/globals-base'
import {Sync} from '../../client/sync'
import {SyncEvents} from '../../client/sync-events'
import {Board} from '../../extensions/board'
import {MessageBox} from '../message-box'

interface CreateNewProps {
  inBoardId?: DataObjectId
  from?: HubJSON
}

export const createNewPhantom = (props: CreateNewProps): Hub | undefined => {
  const {inBoardId, from} = props
  const companyId = globals.getCompanyId()
  const box = Sync.getCurrentSandbox()
  const inBoard = box.getHub(inBoardId)
  const hub = from
    ? new Hub(companyId, '').fromJSON(companyId, from)
    : new Hub(companyId, '')
  hub.id = createDataObjectId()
  hub.title = hub.id
  hub.location = repeatTemplatesContainerId
  const column = from ? box.getHub(from.location) : undefined
  const columnId =
    column && column.location === inBoardId
      ? column.id
      : inBoard &&
        Board.listColumns(inBoard, {sorted: true, noMirrors: true})?.[0]?.id
  if (!columnId) {
    MessageBox.warn(Lang.msg.repeat.noColumnsWarn)
    return undefined
  }
  hub.data.repeatTemplate =
    from?.data.repeatTemplate ??
    createDefaultRepeatTemplate({
      columnId,
      id: hub.id,
      title: from?.title ?? ''
    })
  hub.onCommit(() =>
    SyncEvents.trigger(companyId, [hub.id, hub.location], false)
  )
  box.addPhantom(hub, repeatTemplatesContainerId)
  SyncEvents.trigger(companyId, [hub.id, hub.location], false)

  return hub
}
